module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"running":"Running","notRunning":"Not running","runningTime":"Operating hours"},"de":{"running":"In Betrieb","notRunning":"Ausser Betrieb","runningTime":"Betriebsstunden"},"fr":{"running":"En fonctionnement","notRunning":"Hors fonctionnement","runningTime":"Heures de fonctionnement"},"it":{"running":"In uso","notRunning":"Fuori uso","runningTime":"Ore di funzionamento"}}')
  delete Component.options._Ctor
}
